module.exports = __webpack_public_path__ + "static/media/accept.d839e50d.svg";